import { createApi } from '@reduxjs/toolkit/query/react'

import { axiosBaseQuery } from './api'

// initialize an empty api service that we'll inject endpoints into later as needed
export const signupApi = createApi({
  reducerPath: 'signupApi',
  baseQuery: axiosBaseQuery({ baseUrl: 'quoting/' }),
  refetchOnReconnect: true,
  tagTypes: [
    'AdditionalDrivers',
    'Addons',
    'Flags',
    'PaymentSchedule',
    'PolicyHolder',
    'Price',
    'Quote',
    'RequiredChecks',
    'Vehicle',
  ],
  endpoints: () => ({}),
})
